import { ReactElement } from 'react'
import illustration from '../images/Tonno5.jpg'
import StageContent from '../components/StageContent'
import StageTitle from '../components/StageTitle'
import StageText from '../components/StageText'
import StageOptions from '../components/StageOptions'

const options = [
  {
    text: 'Aloita seikkailu alusta',
    gotoStage: 1
  }
]

interface Props {
  onStageChange: (stage: number) => void
}

const TonnoStage5 = ({ onStageChange }: Props): ReactElement => {
  return (
    <StageContent illustration={illustration}>
      <StageTitle>Onnittelut!</StageTitle>
      <StageText>
        Selvisit Tönnön kylän seikkailusta!
      </StageText>
      <StageText>
        Kylällämme olisi vielä monen monta muutakin tarinaa kerrottavaksi juuri sinulle. Pakkaa eväät mukaasi, kahvia termariin ja tule Tönnön sillalle nautiskelemaan luonnosta ja rauhallisuudesta. Tai ehkäpä jopa tosielämän seikkailusta?
      </StageText>
      <StageText>
        Miten vain, niin pääset suunnittelemaan reissuasi ja lukemaan lisää täältä: <a href="https://tonno.fi" target='_blank'>https://tonno.fi</a>
      </StageText>
      <StageText>
        <strong>Tiesitkö muuten, että Tönnön kylä on valittu Päijät-Hämeen Vuoden Kyläksi vuonna 2013?</strong>
      </StageText>
      <StageOptions options={options} onSelect={onStageChange} />
    </StageContent>
  )
}

export default TonnoStage5
